/*
 * Product reviews below the product. Fetches a page at a time from the help
 * centre and draws stars with the theme's own .rating-star rule, so they match
 * the ones the rating block puts in the header.
 */
(function () {
  if (customElements.get('abu-reviews')) {
    return;
  }

  function stars(value, iconClass) {
    var whole = Math.floor(value);
    var fraction = value - whole;
    var decimal = fraction > 0.7 ? 1 : fraction >= 0.3 ? 0.5 : 0;
    var span = document.createElement('span');
    span.className = 'rating-star ' + iconClass;
    span.setAttribute('aria-hidden', 'true');
    span.style.setProperty('--rating', String(whole));
    span.style.setProperty('--rating-max', '5');
    span.style.setProperty('--rating-decimal', String(decimal));
    return span;
  }

  function rating(value, iconClass) {
    var wrap = document.createElement('div');
    wrap.className = 'rating';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', value.toFixed(1) + ' / 5');
    wrap.appendChild(stars(value, iconClass));
    return wrap;
  }

  function text(tag, className, content) {
    var node = document.createElement(tag);
    node.className = className;
    node.textContent = content;
    return node;
  }

  class AbuReviews extends HTMLElement {
    connectedCallback() {
      this.page = 0;
      this.pages = 1;
      this.list = this.querySelector('.abu-reviews__list');
      this.summary = this.querySelector('.abu-reviews__summary');
      this.more = this.querySelector('.abu-reviews__more');
      this.more.addEventListener('click', () => this.load());
      this.load();
    }

    url(page) {
      return (
        this.dataset.api.replace(/\/$/, '') +
        '/api/internal/reviews/' +
        this.dataset.region +
        '/products/' +
        this.dataset.product +
        '?page=' +
        page
      );
    }

    load() {
      var next = this.page + 1;
      this.more.disabled = true;

      fetch(this.url(next), { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (!data || data.count === 0) {
            return;
          }

          if (this.page === 0) {
            this.renderSummary(data);
            this.hidden = false;
          }

          data.reviews.forEach((review) => this.list.appendChild(this.renderReview(review)));
          this.page = data.page;
          this.pages = data.pages;
          this.more.hidden = this.page >= this.pages;
        })
        .catch(() => {})
        .finally(() => {
          this.more.disabled = false;
        });
    }

    renderSummary(data) {
      this.summary.replaceChildren(
        rating(data.rating, this.dataset.iconClass),
        text('span', 'abu-reviews__score', data.rating.toFixed(1) + ' / 5'),
        text('span', 'abu-reviews__count', '(' + data.count + ')')
      );
    }

    renderReview(review) {
      var item = document.createElement('li');
      item.className = 'abu-reviews__item';
      item.appendChild(rating(review.rating, this.dataset.iconClass));

      var meta = document.createElement('p');
      meta.className = 'abu-reviews__meta caption';
      meta.appendChild(text('span', 'abu-reviews__name', review.name));

      if (review.date) {
        var when = document.createElement('time');
        when.dateTime = review.date;
        when.textContent = new Date(review.date).toLocaleDateString(this.dataset.locale || undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
        meta.appendChild(when);
      }

      if (review.variant) {
        meta.appendChild(text('span', 'abu-reviews__variant', review.variant));
      }

      item.appendChild(meta);

      // The title is often the comment's own first words; show it only when it says something else.
      if (review.title && !review.comment.startsWith(review.title.replace(/[.\u2026]+$/, ''))) {
        item.appendChild(text('p', 'abu-reviews__title', review.title));
      }

      item.appendChild(text('p', 'abu-reviews__comment', review.comment));

      if (review.photos && review.photos.length) {
        var photos = document.createElement('div');
        photos.className = 'abu-reviews__photos';
        review.photos.forEach(function (src) {
          var link = document.createElement('a');
          link.href = src;
          link.target = '_blank';
          link.rel = 'noopener';
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 96;
          img.height = 96;
          link.appendChild(img);
          photos.appendChild(link);
        });
        item.appendChild(photos);
      }

      if (review.reply) {
        var reply = document.createElement('div');
        reply.className = 'abu-reviews__reply';
        reply.appendChild(text('p', 'abu-reviews__reply-label caption', this.dataset.replyLabel || ''));
        reply.appendChild(text('p', 'abu-reviews__reply-text', review.reply));
        item.appendChild(reply);
      }

      return item;
    }
  }

  customElements.define('abu-reviews', AbuReviews);
})();
